// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-card {
  margin-bottom: 24px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.upload-title {
  margin-bottom: 24px !important;
  font-weight: 700 !important;
  color: #1e293b !important;
}
.sample-image-button {
  margin-bottom: 20px;
}
.sample-image-container {
  margin-bottom: 24px;
  padding: 16px;
  background: rgba(248, 250, 252, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.sample-image-container .sample-image-description {
  text-align: center;
  margin-bottom: 20px;
}
.sample-image-container .sample-image-description .description-title {
  font-weight: 600;
  color: #1e293b;
  font-size: 15px;
}
.sample-image-container .sample-image-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  box-shadow: var(--shadow-md);
}
.sample-image-container .sample-image-wrapper .sample-report-image {
  width: 100%;
  display: block;
}
.sample-image-container .field-highlights {
  height: 100%;
  display: flex;
  align-items: flex-start;
}
.sample-image-container .field-highlights .highlight-box {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 20px;
  box-shadow: var(--shadow-sm);
  width: 100%;
  transition: all 0.3s ease;
}
.sample-image-container .field-highlights .highlight-box:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}
.sample-image-container .field-highlights .highlight-box h3 {
  margin-top: 0;
  margin-bottom: 16px;
  color: #1e293b;
  font-weight: 600;
}
.sample-image-container .field-highlights .highlight-box p {
  margin-bottom: 12px;
  color: #475569;
  line-height: 1.6;
}
.sample-image-container .field-highlights .highlight-box ul {
  padding-left: 20px;
  margin-bottom: 16px;
}
.sample-image-container .field-highlights .highlight-box ul li {
  margin-bottom: 8px;
  color: #64748b;
}
.sample-image-container .field-highlights .highlight-box ul li strong {
  color: #334155;
}
.sample-image-container .field-highlights .highlight-box .green-text {
  color: #10b981;
  font-weight: 600;
}
@media (max-width: 768px) {
  .sample-image-container .field-highlights {
    margin-top: 20px;
  }
}
.field-section {
  margin-bottom: 32px;
}
.field-section .ant-divider {
  margin: 24px 0;
  border-color: #e2e8f0;
}
.field-section .field-instruction {
  margin-bottom: 20px;
  color: #64748b;
  font-size: 14px;
}
.custom-fields-collapse {
  margin-bottom: 24px;
  background: transparent;
}
.custom-fields-collapse .ant-collapse-header {
  padding: 12px 20px !important;
  background: rgba(255, 255, 255, 0.5) !important;
  border-radius: 12px !important;
  font-weight: 600;
  color: var(--float-primary) !important;
  transition: all 0.3s ease;
}
.custom-fields-collapse .ant-collapse-header:hover {
  background: rgba(255, 255, 255, 0.8) !important;
}
.custom-fields-collapse .ant-collapse-content-box {
  padding: 20px !important;
  background: rgba(255, 255, 255, 0.3) !important;
  border-radius: 0 0 12px 12px;
  margin-top: 4px;
}
.custom-form-item-label {
  margin-bottom: 0 !important;
}
.custom-form-item-label .ant-form-item-label {
  margin-bottom: 8px;
}
.custom-form-item-label .ant-form-item-label label {
  color: #475569;
}
.upload-area {
  border: 2px dashed rgba(79, 70, 229, 0.2);
  border-radius: 16px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.4);
  padding: 32px;
  position: relative;
}
.upload-area:hover {
  border-color: var(--float-primary);
  background: rgba(79, 70, 229, 0.02);
}
.upload-area.drag-over {
  border-color: var(--float-primary);
  background: rgba(79, 70, 229, 0.05);
  transform: scale(1.01);
  box-shadow: 0 10px 30px rgba(79, 70, 229, 0.1);
}
.upload-area.drag-over .ant-upload-drag-icon .anticon {
  color: var(--float-primary);
  animation: bounce 0.6s ease-in-out infinite alternate;
}
.upload-area.drag-over .ant-upload-text {
  color: var(--float-primary);
  font-weight: 600;
}
.upload-area.drag-over .ant-upload-hint {
  color: var(--float-primary-light);
}
@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-8px);
  }
}
.upload-dragger-wrapper {
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
}
.upload-dragger-wrapper:hover .ant-upload-drag-icon .anticon {
  color: var(--float-primary);
  transform: scale(1.1);
}
.upload-dragger-wrapper:hover .ant-upload-text {
  color: var(--float-primary);
}
.upload-dragger-content {
  padding: 20px 0;
  text-align: center;
  pointer-events: none;
}
.upload-dragger-content .upload-button {
  pointer-events: auto;
}
.ant-upload-drag-icon {
  margin-bottom: 20px;
}
.ant-upload-drag-icon .anticon {
  font-size: 56px;
  color: #cbd5e1;
  transition: all 0.3s ease;
}
.ant-upload-text {
  font-size: 18px;
  margin-bottom: 12px;
  color: #1e293b;
  font-weight: 600;
  transition: all 0.3s ease;
}
.ant-upload-hint {
  color: #64748b;
  margin-bottom: 24px;
  font-size: 14px;
}
.upload-button {
  margin-top: 12px;
}
.file-list-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 200px;
}
.upload-area.drag-over .file-list-container .file-list {
  border-color: var(--float-primary);
  background: rgba(255, 255, 255, 0.8);
}
.upload-area.drag-over .file-list-container .drag-hint {
  color: var(--float-primary) !important;
  font-weight: 600;
}
.file-list-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 16px;
}
.file-list-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}
.file-list-info .drag-hint {
  font-size: 13px;
  color: #94a3b8;
}
.file-list {
  max-height: 320px;
  overflow-y: auto;
  margin-bottom: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.4);
  /* Custom Scrollbar */
}
.file-list::-webkit-scrollbar {
  width: 6px;
}
.file-list::-webkit-scrollbar-track {
  background: transparent;
}
.file-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.file-item {
  padding: 16px 20px;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
.file-item:last-child {
  border-bottom: none;
}
.file-item:hover {
  background: rgba(255, 255, 255, 0.8);
}
.file-item:hover .ant-list-item-action {
  opacity: 1;
}
.file-item .ant-list-item-action {
  opacity: 0.6;
  transition: opacity 0.3s;
}
.file-item .ant-list-item-action .ant-btn:hover {
  background: #fee2e2;
  border-color: #ef4444;
  color: #ef4444;
}
.file-icon {
  font-size: 28px;
  margin-right: 16px;
}
.file-icon.pdf {
  color: #ef4444;
  filter: drop-shadow(0 2px 4px rgba(239, 68, 68, 0.3));
}
.file-icon.image {
  color: #3b82f6;
  filter: drop-shadow(0 2px 4px rgba(59, 130, 246, 0.3));
}
.file-info {
  flex: 1;
  overflow: hidden;
}
.file-name {
  display: block;
  max-width: 500px;
  font-weight: 500;
  color: #1e293b;
}
.file-meta {
  margin-top: 6px;
}
.file-type {
  font-size: 11px;
  padding: 2px 8px;
  background: #f1f5f9;
  border-radius: 4px;
  color: #64748b;
  font-weight: 600;
}
.process-button {
  margin-top: 12px;
  height: 44px;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.model-selector {
  margin-bottom: 20px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
}
.api-error-message {
  color: #dc2626;
  margin-top: 12px;
  padding: 10px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.api-error-message .anticon {
  margin-right: 8px;
}
.sample-image-description {
  margin-bottom: 20px;
  text-align: left;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  padding: 16px 20px;
  border-left: 4px solid var(--float-primary);
  box-shadow: var(--shadow-sm);
}
.sample-image-description .description-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--float-primary);
}
.sample-image-description .description-title .anticon {
  margin-right: 8px;
}
.sample-image-description p {
  margin-bottom: 0;
  color: #475569;
}
.sample-image-description .green-text {
  color: #10b981;
  font-weight: 600;
}
.test-items-section {
  margin-bottom: 24px;
}
.test-items-section .ant-divider {
  margin: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/FileUploader.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oCAAA;EACA,2BAAA;EACA,0CAAA;AACF;AAEA;EACE,8BAAA;EACA,2BAAA;EACA,yBAAA;AAAF;AAIA;EACE,mBAAA;AAFF;AAKA;EACE,mBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,0CAAA;AAHF;AAFA;EAQI,kBAAA;EACA,mBAAA;AAHJ;AANA;EAYM,gBAAA;EACA,cAAA;EACA,eAAA;AAHN;AAXA;EAmBI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,4BAAA;AALJ;AApBA;EA4BM,WAAA;EACA,cAAA;AALN;AAxBA;EAkCI,YAAA;EACA,aAAA;EACA,uBAAA;AAPJ;AA7BA;EAuCM,oCAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,yBAAA;AAPN;AASM;EACE,2BAAA;EACA,4BAAA;AAPR;AA1CA;EAqDQ,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AARR;AAhDA;EA4DQ,mBAAA;EACA,cAAA;EACA,gBAAA;AATR;AArDA;EAkEQ,kBAAA;EACA,mBAAA;AAVR;AAzDA;EAsEU,kBAAA;EACA,cAAA;AAVV;AA7DA;EA0EY,cAAA;AAVZ;AAhEA;EAgFQ,cAAA;EACA,gBAAA;AAbR;AAkBE;EAAA;IAEI,gBAAA;EAhBJ;AACF;AAqBA;EACE,mBAAA;AAnBF;AAkBA;EAII,cAAA;EACA,qBAAA;AAnBJ;AAcA;EASI,mBAAA;EACA,cAAA;EACA,eAAA;AApBJ;AAyBA;EACE,mBAAA;EACA,uBAAA;AAvBF;AAqBA;EAKI,6BAAA;EACA,+CAAA;EACA,8BAAA;EACA,gBAAA;EACA,sCAAA;EACA,yBAAA;AAvBJ;AAyBI;EACE,+CAAA;AAvBN;AAUA;EAkBI,wBAAA;EACA,+CAAA;EACA,4BAAA;EACA,eAAA;AAzBJ;AA6BA;EACE,2BAAA;AA3BF;AA0BA;EAII,kBAAA;AA3BJ;AAuBA;EAOM,cAAA;AA3BN;AAgCA;EACE,yCAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;AA9BF;AAgCE;EACE,kCAAA;EACA,mCAAA;AA9BJ;AAkCA;EACE,kCAAA;EACA,mCAAA;EACA,sBAAA;EACA,8CAAA;AAhCF;AA4BA;EAOI,2BAAA;EACA,qDAAA;AAhCJ;AAwBA;EAYI,2BAAA;EACA,gBAAA;AAjCJ;AAoBA;EAiBI,iCAAA;AAlCJ;AAsCA;EACE;IAAK,wBAAA;EAnCL;EAoCA;IAAO,2BAAA;EAjCP;AACF;AAoCA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AAlCF;AAoCE;EAEI,2BAAA;EACA,qBAAA;AAnCN;AAgCE;EAOI,2BAAA;AApCN;AAyCA;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;AAvCF;AAoCA;EAMI,oBAAA;AAvCJ;AA2CA;EACE,mBAAA;AAzCF;AAwCA;EAII,eAAA;EACA,cAAA;EACA,yBAAA;AAzCJ;AA6CA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AA3CF;AA8CA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AA5CF;AA+CA;EACE,gBAAA;AA7CF;AAgDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AA9CF;AAgDE;EAEI,kCAAA;EACA,oCAAA;AA/CN;AA4CE;EAOI,sCAAA;EACA,gBAAA;AAhDN;AAqDA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAnDF;AAsDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;AApDF;AAgDA;EAOI,eAAA;EACA,cAAA;AApDJ;AAwDA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;EAtDA,qBAAqB;AACvB;AAwDE;EACE,UAAA;AAtDJ;AAwDE;EACE,uBAAA;AAtDJ;AAwDE;EACE,mBAAA;EACA,mBAAA;AAtDJ;AA0DA;EACE,kBAAA;EACA,yBAAA;EACA,4CAAA;AAxDF;AA0DE;EACE,mBAAA;AAxDJ;AA2DE;EACE,oCAAA;AAzDJ;AAwDE;EAII,UAAA;AAzDN;AA4CA;EAkBI,YAAA;EACA,wBAAA;AA3DJ;AA8DM;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA5DR;AAkEA;EACE,eAAA;EACA,kBAAA;AAhEF;AAkEE;EACE,cAAA;EACA,qDAAA;AAhEJ;AAmEE;EACE,cAAA;EACA,sDAAA;AAjEJ;AAqEA;EACE,OAAA;EACA,gBAAA;AAnEF;AAsEA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AApEF;AAuEA;EACE,eAAA;AArEF;AAwEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAtEF;AAyEA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAvEF;AA0EA;EACE,mBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;AAxEF;AA2EA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAzEF;AAgEA;EAYI,iBAAA;AAzEJ;AA6EA;EACE,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,4BAAA;AA3EF;AAoEA;EAUI,gBAAA;EACA,kBAAA;EACA,2BAAA;AA3EJ;AA+DA;EAeM,iBAAA;AA3EN;AA4DA;EAoBI,gBAAA;EACA,cAAA;AA7EJ;AAwDA;EAyBI,cAAA;EACA,gBAAA;AA9EJ;AAkFA;EACE,mBAAA;AAhFF;AA+EA;EAII,cAAA;AAhFJ","sourcesContent":[".upload-card {\n  margin-bottom: 24px;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n.upload-title {\n  margin-bottom: 24px !important;\n  font-weight: 700 !important;\n  color: #1e293b !important;\n}\n\n// 示例图片相关样式\n.sample-image-button {\n  margin-bottom: 20px;\n}\n\n.sample-image-container {\n  margin-bottom: 24px;\n  padding: 16px;\n  background: rgba(248, 250, 252, 0.6);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  \n  .sample-image-description {\n    text-align: center;\n    margin-bottom: 20px;\n    \n    .description-title {\n      font-weight: 600;\n      color: #1e293b;\n      font-size: 15px;\n    }\n  }\n  \n  .sample-image-wrapper {\n    position: relative;\n    width: 100%;\n    height: auto;\n    overflow: hidden;\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    border-radius: 8px;\n    box-shadow: var(--shadow-md);\n    \n    .sample-report-image {\n      width: 100%;\n      display: block;\n    }\n  }\n  \n  .field-highlights {\n    height: 100%;\n    display: flex;\n    align-items: flex-start;\n    \n    .highlight-box {\n      background: rgba(255, 255, 255, 0.8);\n      border: 1px solid rgba(0, 0, 0, 0.05);\n      border-radius: 12px;\n      padding: 20px;\n      box-shadow: var(--shadow-sm);\n      width: 100%;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: var(--shadow-md);\n      }\n      \n      h3 {\n        margin-top: 0;\n        margin-bottom: 16px;\n        color: #1e293b;\n        font-weight: 600;\n      }\n      \n      p {\n        margin-bottom: 12px;\n        color: #475569;\n        line-height: 1.6;\n      }\n      \n      ul {\n        padding-left: 20px;\n        margin-bottom: 16px;\n        \n        li {\n          margin-bottom: 8px;\n          color: #64748b;\n          \n          strong {\n            color: #334155;\n          }\n        }\n      }\n      \n      .green-text {\n        color: #10b981;\n        font-weight: 600;\n      }\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .field-highlights {\n      margin-top: 20px;\n    }\n  }\n}\n\n// 必填字段区域样式\n.field-section {\n  margin-bottom: 32px;\n  \n  .ant-divider {\n    margin: 24px 0;\n    border-color: #e2e8f0;\n  }\n  \n  .field-instruction {\n    margin-bottom: 20px;\n    color: #64748b;\n    font-size: 14px;\n  }\n}\n\n// 自定义字段折叠面板样式\n.custom-fields-collapse {\n  margin-bottom: 24px;\n  background: transparent;\n  \n  .ant-collapse-header {\n    padding: 12px 20px !important;\n    background: rgba(255, 255, 255, 0.5) !important;\n    border-radius: 12px !important;\n    font-weight: 600;\n    color: var(--float-primary) !important;\n    transition: all 0.3s ease;\n    \n    &:hover {\n      background: rgba(255, 255, 255, 0.8) !important;\n    }\n  }\n  \n  .ant-collapse-content-box {\n    padding: 20px !important;\n    background: rgba(255, 255, 255, 0.3) !important;\n    border-radius: 0 0 12px 12px;\n    margin-top: 4px;\n  }\n}\n\n.custom-form-item-label {\n  margin-bottom: 0 !important;\n  \n  .ant-form-item-label {\n    margin-bottom: 8px;\n    \n    label {\n      color: #475569;\n    }\n  }\n}\n\n.upload-area {\n  border: 2px dashed rgba(79, 70, 229, 0.2);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.4);\n  padding: 32px;\n  position: relative;\n  \n  &:hover {\n    border-color: var(--float-primary);\n    background: rgba(79, 70, 229, 0.02);\n  }\n}\n\n.upload-area.drag-over {\n  border-color: var(--float-primary);\n  background: rgba(79, 70, 229, 0.05);\n  transform: scale(1.01);\n  box-shadow: 0 10px 30px rgba(79, 70, 229, 0.1);\n  \n  .ant-upload-drag-icon .anticon {\n    color: var(--float-primary);\n    animation: bounce 0.6s ease-in-out infinite alternate;\n  }\n  \n  .ant-upload-text {\n    color: var(--float-primary);\n    font-weight: 600;\n  }\n  \n  .ant-upload-hint {\n    color: var(--float-primary-light);\n  }\n}\n\n@keyframes bounce {\n  0% { transform: translateY(0); }\n  100% { transform: translateY(-8px); }\n}\n\n// 自定义上传拖拽区域样式\n.upload-dragger-wrapper {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s;\n  \n  &:hover {\n    .ant-upload-drag-icon .anticon {\n      color: var(--float-primary);\n      transform: scale(1.1);\n    }\n    \n    .ant-upload-text {\n      color: var(--float-primary);\n    }\n  }\n}\n\n.upload-dragger-content {\n  padding: 20px 0;\n  text-align: center;\n  pointer-events: none;\n  \n  .upload-button {\n    pointer-events: auto;\n  }\n}\n\n.ant-upload-drag-icon {\n  margin-bottom: 20px;\n  \n  .anticon {\n    font-size: 56px;\n    color: #cbd5e1;\n    transition: all 0.3s ease;\n  }\n}\n\n.ant-upload-text {\n  font-size: 18px;\n  margin-bottom: 12px;\n  color: #1e293b;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.ant-upload-hint {\n  color: #64748b;\n  margin-bottom: 24px;\n  font-size: 14px;\n}\n\n.upload-button {\n  margin-top: 12px;\n}\n\n.file-list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-height: 200px;\n  \n  .upload-area.drag-over & {\n    .file-list {\n      border-color: var(--float-primary);\n      background: rgba(255, 255, 255, 0.8);\n    }\n    \n    .drag-hint {\n      color: var(--float-primary) !important;\n      font-weight: 600;\n    }\n  }\n}\n\n.file-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n  gap: 16px;\n}\n\n.file-list-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  \n  .drag-hint {\n    font-size: 13px;\n    color: #94a3b8;\n  }\n}\n\n.file-list {\n  max-height: 320px;\n  overflow-y: auto;\n  margin-bottom: 20px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.4);\n  \n  /* Custom Scrollbar */\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 10px;\n  }\n}\n\n.file-item {\n  padding: 16px 20px;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n  \n  &:last-child {\n    border-bottom: none;\n  }\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.8);\n    \n    .ant-list-item-action {\n      opacity: 1;\n    }\n  }\n  \n  .ant-list-item-action {\n    opacity: 0.6;\n    transition: opacity 0.3s;\n    \n    .ant-btn {\n      &:hover {\n        background: #fee2e2;\n        border-color: #ef4444;\n        color: #ef4444;\n      }\n    }\n  }\n}\n\n.file-icon {\n  font-size: 28px;\n  margin-right: 16px;\n  \n  &.pdf {\n    color: #ef4444;\n    filter: drop-shadow(0 2px 4px rgba(239, 68, 68, 0.3));\n  }\n  \n  &.image {\n    color: #3b82f6;\n    filter: drop-shadow(0 2px 4px rgba(59, 130, 246, 0.3));\n  }\n}\n\n.file-info {\n  flex: 1;\n  overflow: hidden;\n}\n\n.file-name {\n  display: block;\n  max-width: 500px;\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.file-meta {\n  margin-top: 6px;\n}\n\n.file-type {\n  font-size: 11px;\n  padding: 2px 8px;\n  background: #f1f5f9;\n  border-radius: 4px;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.process-button {\n  margin-top: 12px;\n  height: 44px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.model-selector {\n  margin-bottom: 20px;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  display: flex;\n  flex-direction: column;\n}\n\n.api-error-message {\n  color: #dc2626;\n  margin-top: 12px;\n  padding: 10px 16px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  \n  .anticon {\n    margin-right: 8px;\n  }\n}\n\n.sample-image-description {\n  margin-bottom: 20px;\n  text-align: left;\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 12px;\n  padding: 16px 20px;\n  border-left: 4px solid var(--float-primary);\n  box-shadow: var(--shadow-sm);\n  \n  .description-title {\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: var(--float-primary);\n    \n    .anticon {\n      margin-right: 8px;\n    }\n  }\n  \n  p {\n    margin-bottom: 0;\n    color: #475569;\n  }\n  \n  .green-text {\n    color: #10b981;\n    font-weight: 600;\n  }\n}\n\n.test-items-section {\n  margin-bottom: 24px;\n  \n  .ant-divider {\n    margin: 20px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
